import TeamAvatars from './TeamAvatars';

export default TeamAvatars;
